import {DragLayer} from 'react-dnd';
import CustomDragLayer from './DragLayer';

export default DragLayer(monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging()
}))(CustomDragLayer);
